import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, Typography } from "@material-ui/core";
import RestoreIcon from '@material-ui/icons/Restore';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import ErrorIcon from '@material-ui/icons/Error';
import { TooltipTop as CustomTooltip } from "../../../Common/CustomTooltips";
import styles from "./styles";
import t from "../../../../languages/pl";

const useStyles = makeStyles(theme => styles(theme, ({ })));

const Route = props => {
    const { time, type, description } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    const pickIcon = (type) => {
        switch(type) {
            case "info":
                return <InfoIcon />;
            case "warning":
                return <WarningIcon />;
            case "danger":
                return <ErrorIcon />;
            default:
                return <WarningIcon />;
        }
    };

    return (
        <React.Fragment>
            <div className={classes.location}>
                <CustomTooltip title={t.incidentDate}>
                    <RestoreIcon />
                </CustomTooltip>
                &nbsp;<Typography
                    variant="body2"
                >
                    {time}
                </Typography>
            </div>
            <div className={classes.location}>
                <CustomTooltip title={t.incidentInfo}>
                   {pickIcon(type)}
                </CustomTooltip>&nbsp;
                <Typography
                    variant="body2"
                >
                    {description}
                </Typography>
            </div>
        </React.Fragment>
    );
};

Route.propTypes = {
    time: PropTypes.string,
    type: PropTypes.string,
    description: PropTypes.string,
};

export default Route;
